export function isFuseGridDesktop(): boolean {
  // We set this from `src-tauri/src/lib.rs` during Tauri setup as a reliable signal.
  const w = globalThis as any;
  if (w && w.__FG_DESKTOP__ === true) return true;

  // Fallback heuristic (works in most Tauri contexts)
  return !!(w && (w.__TAURI__ || w.__TAURI_INTERNALS__));
}

export function isFuseGridElectronDesktop(): boolean {
  // ONLY the preload-injected invoke bridge counts. Do NOT sniff the user agent:
  // plenty of third-party browsers embed Electron and advertise it in their UA
  // (e.g. the Claude desktop app's browser pane ships "Electron/42.x"), but they
  // have no FuseGrid bridge. A UA match without the bridge made desktop
  // detection split-brained — the worker routed DuckDB to native HOST_CALLs
  // while WorkerBus (which correctly checks the bridge) rejected them, killing
  // the GL detail page in any Electron-embedded webview. The real FuseGrid
  // Electron shell always defines __FG_ELECTRON_INVOKE__ in its preload, which
  // runs before any page script, so the bridge check alone is authoritative.
  const w = globalThis as any
  return !!(w && typeof w.__FG_ELECTRON_INVOKE__ === 'function')
}

export function isFuseGridNativeDesktopShell(): boolean {
  // "Native desktop shell" = Tauri OR Electron.
  return isFuseGridDesktop() || isFuseGridElectronDesktop()
}

export function isFuseGridWebFirstTableauCreatorEnabled(): boolean {
  return true
}

export function areFuseGridLocalPackageWorkflowsEnabled(): boolean {
  return !isFuseGridWebFirstTableauCreatorEnabled()
}
